import { createSlice, PayloadAction } from "@reduxjs/toolkit"

export interface SongActionItem {
  id: number
  title: string
  nada_url: string
  streaming_url?: string
  post_type?: string
  band_id?: number
  band_name?: string
  album_id?: number
  album_name?: string
  album_path?: string
  cover_image_small?: string
  external_photo_src?: string
  local_path?: string
  nada_path?: string
  parent_path?: string
  duration?: number
  playlistId?: number
}

interface SongActionsState {
  isOpen: boolean
  song: SongActionItem | null
}

const initialState: SongActionsState = {
  isOpen: false,
  song: null,
}

export const songActionsSlice = createSlice({
  name: "songActions",
  initialState,
  reducers: {
    openSongActions: (state, action: PayloadAction<SongActionItem>) => {
      state.isOpen = true
      state.song = action.payload
    },
    closeSongActions: (state) => {
      state.isOpen = false
      state.song = null
    },
  },
})

export const { openSongActions, closeSongActions } = songActionsSlice.actions
export default songActionsSlice.reducer
